export const constructUriWithSearchParams = (
  urlAsString: string,
  paramsToAdd: Record<string, string>
) => {
  let urlAsObject = new URL(urlAsString);

  for (const [key, value] of Object.entries(paramsToAdd)) {
    urlAsObject.searchParams.append(key, value);
  }

  return urlAsObject.toString();
};
